import React from "react"
import { AspectRatio, AspectRatioProps, Box, BoxProps, Button } from "@chakra-ui/react"

import Image from "@components/Image/Image"
import Link from "@components/Link"

export type CalloutTileSize = "large" | "medium" | "small"
export type CalloutCTAToggle = "On" | "Off"

export interface CalloutTileProps {
  image: NormalisedImage
  link?: NormalisedLink
  size?: CalloutTileSize
  toggle?: CalloutCTAToggle
}

const getAspectRatio = (size: CalloutTileSize): AspectRatioProps["ratio"] => {
  switch (size) {
    case "large":
      return [1, 324 / 271]
    case "medium":
      return [1, 427 / 456]
    case "small":
      return 4 / 5
  }
}

const CalloutTile = ({ image, link, size = "large", toggle }: CalloutTileProps) => {
  const aspectRatio = getAspectRatio(size)
  const boxProps: BoxProps = { pos: "relative", w: "full" }

  const content = (
    <>
      <AspectRatio ratio={aspectRatio}>
        <Image {...image} objectFit="cover" borderRadius="xxs" />
      </AspectRatio>
      {link && (
        toggle == "On" ?
        <Button
          px={2.5}
          pointerEvents="none"
          variant="blue"
          size="md"
          position="absolute"
          top="95%"
          left="50%"
          transform="translate(-50%, -95%)"
        >
          {link.title}
        </Button>
        :
        null
      )}
    </>
  )

  return link ? (
    <Box as={Link} to={link.url} {...boxProps}>
      {content}
    </Box>
  ) : (
    <Box {...boxProps}>{content}</Box>
  )
}

export default React.memo(CalloutTile)
